// src/Support.js
import React from 'react';
import { Link } from 'react-router-dom';

function Support() {
  return (
    <div className="left-align">
      <h1>Support</h1>
      <p>
        Need help with Fampack? Email{' '}
        <a href="mailto:team@fampack.net">team@fampack.net</a>.
      </p>

      <h2>Delete your account</h2>
      <p>
        In the iPhone app, go to Settings → Account → Delete account. If your
        account is suspended or banned, use Delete account on the locked screen.
        You will enter a fresh sign-in code, then the account is hidden and
        scheduled for deletion 30 days later. Signing in to the iPhone app before
        deletion starts cancels it. The website cannot delete or cancel an
        account deletion.
      </p>

      <h2>Report or block</h2>
      <p>
        To report a post, comment or account, open its menu in the app, choose
        Report and pick a reason. To block an account, open the account's profile
        menu and choose Block. You can also block after reporting an account.
      </p>

      <h2>Legal</h2>
      <p>
        Read the <Link to="/terms">Terms of Service</Link> and{' '}
        <Link to="/privacy">Privacy Policy</Link>.
      </p>
    </div>
  );
}

export default Support;
